import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { css } from "styled-components";

imageStyles.container = {
    gap: 5,
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
            margin: 0 auto;
        }
    `,
};

imageStyles.linksContainer = {
    gap: 20,
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
            margin: 0 auto;
        }
    `,
};

imageStyles.imageMissingText = {
    variant: "h3",
    css: css`
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        text-align: center;
    `,
};

imageStyles.productLinkItem = {
    width: 12,
    css: css`
        justify-content: center;
        text-align: center;
        > a[data-test-selector^="brandToProductPageLink"] {
            background: rgb(39, 90, 168);
            border: 2px solid rgb(39, 90, 168);
            padding: 10px;
            &:hover {
                background: rgb(0, 0, 255);
                border-color: rgb(0, 0, 255);
            }
            > span[class^="TypographyStyle"] {
                color: #fff;
            }
        }
    `,
};
